import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import FormControl, { FormControlProps } from '@mui/material/FormControl'
import { connectField, getValueByPath, useFormContext } from 'dynamic-uniforms'
import cloneDeep from 'lodash/cloneDeep'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { filterDOMProps } from './filterDOMProps'
import { joinName } from './joinName'

export type ListAddFieldProps = {
  fullWidth?: FormControlProps['fullWidth']
  icon?: ReactNode
  margin?: FormControlProps['margin']
  variant?: FormControlProps['variant']
  cta?: string
  disabled?: boolean
  readOnly?: boolean
  name: string
  value?: unknown
  [key: string]: any
}

function ListAdd({
  cta,
  disabled,
  fullWidth = true,
  icon = <AddIcon />,
  margin = 'dense',
  name,
  readOnly,
  value,
  variant,
  ...props
}: ListAddFieldProps) {
  const { t } = useTranslation('@cibo/ui/Uniforms')
  const ctx = useFormContext()

  const nameParts = joinName(null, name) as string[]
  const parentName = joinName(nameParts.slice(0, -1)) as string
  const parentProps = ctx.bridge.getProps(parentName)
  const parentValue = (getValueByPath(ctx.model, parentName) ?? []) as unknown[]

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const limitNotReached = !disabled && !(parentProps.maxCount! <= parentValue.length)

  return (
    <FormControl fullWidth={fullWidth} margin={margin} variant={variant}>
      <Button
        data-testid={`list-add-button-${parentName}`}
        variant="text"
        {...filterDOMProps(props)}
        disabled={!limitNotReached}
        endIcon={icon}
        onClick={() => {
          if (!readOnly) {
            const newItem = value !== undefined ? cloneDeep(value) : {}
            ctx.onChange(parentName, parentValue.concat([newItem]))
          }
        }}
      >
        {cta || t('addItem')}
      </Button>
    </FormControl>
  )
}

export default connectField<ListAddFieldProps>(ListAdd, {
  initialValue: false,
  kind: 'leaf',
})
